<ngx-loading-bar></ngx-loading-bar>
<ui-view></ui-view>
